import md5 from 'js-md5';
import { GetUserAllSettings, sendLoginCode } from '@/http/api';
let timer = null
export default {
  data() {
    return {
      show: false,
      flag: false,
      loginLoad: false,
      env: this.$ENV,
      ruleForm: {
        userName: '',
        passWord: '',
        smsCode: ''
      },
      smsButtonDisabled: false, // 控制发送验证码按钮是否禁用
      smsButtonText: '发送验证码', // 发送验证码按钮的文字
      smsCountdown: 60, // 倒计时时间（秒）
      redirect: undefined,
      otherQuery: {},
      rules: {
        userName: [
          {
            required: true,
            message: '账号不能为空',
            trigger: ['change', 'blur'],
          },
        ],
        passWord: [
          {
            required: true,
            message: '密码不能为空',
            trigger: ['change', 'blur'],
          },
        ],
        smsCode: [
          {
            required: true,
            message: '短信验证码不能为空',
            trigger: ['change', 'blur'],
          },
        ],
      },

    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  methods: {
    loginEvent() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loginLoad = true;
          let params = {
            userName: this.ruleForm.userName,
            passWord: md5(this.ruleForm.userName + this.ruleForm.passWord),
          }
          if (this.$ENV.ISSMSCODESHOW) Object.assign({
            smsCode: this.ruleForm.smsCode,
          }, params)
          this.$store
            .dispatch('actionsLogin', params)
            .then((isValid) => {
              if (isValid) {
                this.$prompt('请输入密码', '二次验证', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  inputPattern: /\w{6,}/,
                  inputErrorMessage: '密码不能为空',
                }).then(({ value }) => {
                  Object.assign({
                    passWord: md5(this.ruleForm.userName + value),
                  }, params)
                  this.$store
                    .dispatch('actionAuthLogin', params)
                    .then((_) => {
                      this.$router.push('/layout/home');
                      GetUserAllSettings().then((res) => {
                        localStorage.setItem('columnArr', JSON.stringify(res));
                      });
                    })
                    .finally((_) => (this.loginLoad = false));
                });
              } else {
                this.$router.push('/layout/home');
                GetUserAllSettings().then((res) => {
                  localStorage.setItem('columnArr', JSON.stringify(res));
                });
              }
            })
            .finally(() => {
              this.loginLoad = false;
            });
        }
      });
    },
    // 发送短信验证码
    sendSmsCode() {
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.userName)) {
        this.$message.error('请输入正确的手机号码');
        return
      }
      // 模拟发送短信验证码s
      if (this.smsButtonDisabled) return
      sendLoginCode(this.ruleForm.userName).then(_ => {
        this.smsButtonDisabled = true;
        if (timer) clearInterval(timer)
        this.$message({
          message: '验证码已发送',
          type: 'success',
        });
        // 开始倒计时
        timer = setInterval(() => {
          this.smsCountdown--;
          this.smsButtonText = `${this.smsCountdown} 秒后重新发送`;

          if (this.smsCountdown <= 0) {
            clearInterval(timer);
            this.smsButtonDisabled = false;
            this.smsButtonText = '发送验证码';
            this.smsCountdown = 60;
          }
        }, 1000);
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    applyHandler() {
      console.log(123);
      this.isShowApplyDialog = true;
    },
  },
};